import useFlyItem from "@/shared/atoms/useFlyItem";
import { motion } from "framer-motion";
import EmptyImg from "../../../App/Assets/Images/empty.png";

const flyTransition = {
  duration: 0.95,
  ease: [0.22, 1, 0.36, 1] as const,
};

const KioskFlyItem = () => {
  const [flyItem, setFlyItem] = useFlyItem();

  if (!flyItem?.enabled) return null;

  const startLeft = flyItem.startX - flyItem.startSize / 2;
  const startTop = flyItem.startY - flyItem.startSize / 2;
  const endLeft = flyItem.endX - flyItem.endSize / 2;
  const endTop = flyItem.endY - flyItem.endSize / 2;

  return (
    <motion.img
      key={flyItem.id}
      src={flyItem.src || EmptyImg}
      alt=""
      className="pointer-events-none fixed left-0 top-0 z-9999 rounded-2xl object-contain shadow-2xl"
      initial={{
        x: startLeft,
        y: startTop,
        width: flyItem.startSize,
        height: flyItem.startSize,
        opacity: 1,
        scale: 1,
      }}
      animate={{
        x: endLeft,
        y: endTop,
        width: flyItem.endSize,
        height: flyItem.endSize,
        opacity: 0.2,
        scale: 0.75,
      }}
      transition={{
        x: flyTransition,
        y: flyTransition,
        width: flyTransition,
        height: flyTransition,
        scale: flyTransition,
        opacity: { duration: 0.55, ease: "easeOut", delay: 0.35 },
      }}
      onAnimationComplete={() => setFlyItem(null)}
    />
  );
};

export default KioskFlyItem;
